<template>
    <div class="relative">
        <div class="overflow-x-auto scrollbar-hidden">
            <table class="table mt-5" id="custom-table">
                <thead class="bg-primary-1 text-white">
                    <tr>
                        <slot name="tablehead"></slot>
                    </tr>
                </thead>
                <tbody>
                    <slot name="tablebody"></slot>
                </tbody>
            </table>
        </div>
        <div class="table-footer">
            <span class="table-paginator">
                <label>แสดง</label>
                <select class="table-page-size" aria-label="แสดง" v-model="rowPerPageComputed">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <button class="table-page btn" type="button" role="button" aria-label="First Page" data-page="first" :disabled="disabledFirst" @click="updatePage('First')">หน้าแรก</button>
                <button class="table-page btn" type="button" role="button" aria-label="Prev Page" data-page="prev" :disabled="disabledPrev" @click="updatePage('Prev')">ก่อนหน้า</button>
                <button class="table-page btn" type="button" role="button" aria-label="Next Page" data-page="next" :disabled="disabledNext" @click="updatePage('Next')">ถัดไป</button>
            </span>
        </div>
        <div class="table-loader" v-if="loadingStatus">
            <div class="loading-text">Loading</div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue"
const props = defineProps({
    rowPerPage: String,
    loadingStatus: Boolean,
    offset: String,
    totalItem: Number
})
const emit = defineEmits(["update:rowPerPage", "update:clickPage"])
const rowPerPageComputed = computed({
  get(){
    return props.rowPerPage || null;
  },
  set(value) {
    emit("update:rowPerPage", value);
  },
});
const updatePage = (value) => {
    emit("update:clickPage", value)
}
const disabledFirst = computed(()=>props.offset == "0" || (props.offset == "0" && (props.totalItem < rowPerPageComputed.value)))
const disabledNext = computed(()=>props.totalItem < rowPerPageComputed.value)
const disabledPrev = computed(()=>props.offset == "0" || (props.offset == "0" && (props.totalItem < rowPerPageComputed.value)))
</script>

<style lang="scss">
#custom-table {
    width: max-content;
    min-width: 100%;
    th{
        font-weight: 700;
        @apply whitespace-nowrap
    }
    tr{
        &:hover td{
            background: rgb(226, 232, 240) !important;
        }
        &:nth-of-type(odd) td{
            background: #FFF;
        }
        &:nth-of-type(even) td{
            background: rgb(237, 242, 247);
        }

    }
}
.table-footer{
    display: flex;
    justify-content: start;
    margin-top: 10px;
    .table-page-size{
        margin-left: 10px;
        margin-right: 5px;
        padding: 0.3rem 2rem 0.3rem 0.75rem;
        border-radius: 0.3rem;
    }
    .table-page {
        background: rgb(226, 232, 240);
        margin-left: 2px;
        margin-right: 2px;
        &:focus{
            box-shadow: unset;
        }
    }
}
.table-loader{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgba(255,255,255,.7);
    .loading-text{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
}
</style>